"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRevalidateDialog = void 0;
const react_1 = require("react");
const detail_context_1 = require("../../../detail/detail-context");
const abortable_fetch_1 = require("../../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
function useRevalidateDialog(url) {
    var _a;
    const callApi = (0, event_callback_hook_1.useEventCallback)((id) => (0, abortable_fetch_1.abortableFetch)(`${url}/${id}/active`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'PUT',
    }));
    const { source } = (0, react_1.useContext)(detail_context_1.DetailContext);
    // TODO
    const showButton = !((_a = source.data) === null || _a === void 0 ? void 0 : _a.active);
    return {
        callApi,
        showButton,
    };
}
exports.useRevalidateDialog = useRevalidateDialog;
//# sourceMappingURL=revalidate-hook.js.map